import { NSALayout, NSALayoutCustomProps } from "namirasoft-account-react";
import { PaymentBase } from "namirasoft-payment";
import { Component, createRef } from "react";

export class SupportLayout<RowType extends { id: string } = any, RowTypeInput = RowType> extends Component<NSALayoutCustomProps<RowType, RowTypeInput>>
{
    NSALayout_Ref = createRef<NSALayout<RowType, RowTypeInput>>();

    override render()
    {
        return (
            <NSALayout
                ref={this.NSALayout_Ref}
                {...this.props}
                header={{
                    built_in: {
                        workspace: false
                    }
                }}
                payment={{
                    sales_item_id: PaymentBase.NAMIRASOFT_SUPPORT.sales_items.MEMBERSHIP.id
                }}
            >
                {this.props.children}
            </NSALayout>
        );
    }
};